import { NumberValue } from '../../../../utils'
import type { DepositSettlement } from '../../types/invoices/depositSettlement'
import type { Invoice } from '../../types/invoices/invoice'

const negate = (amount: number): number => new NumberValue(amount).multiply(-1).getRounded()

// A credit note has no lines of its own to deduct from. It mirrors the source final invoice's payable
// amount with the opposite sign. adjustedSummary is that payable amount; older invoices keep it in summary.
export const getCreditNoteDepositSettlement = (
  sourceInvoice?: Pick<Invoice, 'adjustedSummary' | 'depositDeduction' | 'summary'>,
): DepositSettlement | undefined => {
  if (!sourceInvoice?.depositDeduction) {
    return undefined
  }

  const payableSummary = sourceInvoice.adjustedSummary ?? sourceInvoice.summary

  return {
    amountDue: {
      grossTotal: negate(payableSummary.foreignGrossTotal),
      netTotal: negate(payableSummary.foreignNetTotal),
      taxSummary: (payableSummary.foreignTaxSummary ?? [])
        // A 0% rate has no tax, but the row carries the exemption region.
        .filter((row) => row.amount !== 0 || row.percentage === 0)
        .map((row) => ({ amount: negate(row.amount), percentage: row.percentage })),
      taxTotal: negate(payableSummary.foreignTaxTotal),
    },
    depositGrossTotal: sourceInvoice.depositDeduction.grossTotal,
  }
}
